import PAApi from './_paApi.js';

import httpClient from '@/apis/base/httpclient';
class PAOtherInputSalaryAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PaOtherInputSalarys';
  /**
   * Lấy danh sách khoản lương
   * @param {*} payload
   * @returns
   * PQDat 03.10.2022
   */
  async getPayrollItem(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/payrollItem`,
      data: payload,
    };

    return await httpClient.getAsync(request);
  }
  /**
   * Lấy danh sách khoản lương
   * @param {*} records
   * @returns
   * PQDat 03.10.2022
   */
  async checkIncurredSalaryData(records) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/checkIncurredSalaryData`,
      data: records,
    };

    return await httpClient.postAsync(request);
  }
}

export default new PAOtherInputSalaryAPI();
